import React from 'react';

import {EditSearchColumns} from 'src/components/edit-columns';
import {SearchType} from 'src/openapi/admin/models/SearchType';

import {
    ACCOUNT_SEARCH_COLUMNS,
    ALL_OPTIONS, COLUMNS,
    ITEMS,
    LIMITED_SORT_COLUMNS,
    NO_SORT_COLUMNS,
    OPTIONS_SETTINGS,
    OPTION_GROUPS,
    SORING_LABElS,
} from '../constants';

import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

type Props = {
    place: string,
    adminId: number,
    isLoading: boolean,
    templates: UserSearchTemplate[],
    activeSearchTemplate: UserSearchTemplate,
    setActiveSearchTemplate: (actionProps: UserSearchTemplate) => Promise<string | null>,
    loadTemplates: () => void,
    loadActiveSearchTemplate: () => Promise<void>,
};

export const AccountSearchEditColumns = (props: Props) => (
    <EditSearchColumns
        place={props.place}
        userId={props.adminId}
        searchType={SearchType.ACCOUNT}
        isLoading={props.isLoading}
        templates={props.templates}
        activeTemplate={props.activeSearchTemplate}
        columns={COLUMNS}
        sortingDataMap={SORING_LABElS}
        limitedSortColumns={LIMITED_SORT_COLUMNS}
        noSortColumns={NO_SORT_COLUMNS}
        columnsMap={ACCOUNT_SEARCH_COLUMNS}
        items={ITEMS}
        allOptions={ALL_OPTIONS}
        optionGroups={OPTION_GROUPS}
        optionSettings={OPTIONS_SETTINGS}
        onSetActiveTemplate={props.setActiveSearchTemplate}
        onUpdateTemplates={props.loadTemplates}
        onUpdateColumns={() => {
            props.loadActiveSearchTemplate();
            props.loadTemplates();
        }}
    />
);
